export default __webpack_public_path__ + "static/media/rocket.e78874ab.svg";